import dayjs from "dayjs";
import { SelectedMark } from "../../../../../Icons/ActiveMark";
import "./style.scss";
import { Dropdown, MenuProps } from "antd";
import { DotsMenu } from "../../../../../Icons/DotsMenu";
import { useTranslation } from "react-i18next";

export const PriceCard = ({ data, onCardClick }) => {
  const { t, i18n } = useTranslation();

  if (!data) return null;

  const items: MenuProps["items"] = [
    {
      label: (
        <p className="menu-item edit" onClick={() => onCardClick(data)}>
          {t("form.view")}
        </p>
      ),
      key: "view",
    },
  ];

  return (
    <div className="price-card">
      <h2>
        <span>
          {data?.serviceProvider?.status === "active" && <SelectedMark />}
        </span>
        {data.service?.name?.[i18n.language || "en"] || t("form.uploadedAt")}
      </h2>
      <div className="price-info">
        <p>{dayjs(data.updatedAt).format("DD/MM/YYYY hh:mm")}</p>
      </div>

      <div className="price-menu-action">
        <Dropdown menu={{ items }} trigger={["click"]}>
          <span style={{ cursor: "pointer" }}>
            <DotsMenu />
          </span>
        </Dropdown>
      </div>
    </div>
  );
};
